import { ConcreteEncodable } from "./ConcreteEncodable";

import { AllocationDataImplEncoder } from "../../encoder/AllocationDataImplEncoder";

import * as CubiqTS from "../../index";
import { AllocationData } from "../AllocationData";

export class AllocationDataImpl extends ConcreteEncodable implements AllocationData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.AllocationDataImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=981*/
  public allocationId: CubiqTS.Long | null = null;
  /*FID=982*/
  public riskId: CubiqTS.Long | null = null;
  /*FID=983*/
  public allocationReference: string;
  /*FID=984*/
  public allocationType: CubiqTS.AllocationType;
  /*FID=985*/
  public allocationIntent: CubiqTS.OrderIntent;
  /*FID=986*/
  public accountCode: string;
  /*FID=987*/
  public baseCcy: string;
  /*FID=988*/
  public nonbaseCcy: string;
  /*FID=989*/
  public fixedCcy: string;
  /*FID=990*/
  public allocationProductCd: CubiqTS.Product;
  /*FID=991*/
  public allocationQty: CubiqTS.BigNumber | null = null;
  /*FID=992*/
  public settleQty: CubiqTS.BigNumber | null = null;
  /*FID=993*/
  public leavesQty: CubiqTS.BigNumber | null = null;
  /*FID=994*/
  public leavesSettleQty: CubiqTS.BigNumber | null = null;
  /*FID=995*/
  public usdEquivQty: CubiqTS.BigNumber | null = null;
  /*FID=996*/
  public usdEquivLeavesQty: CubiqTS.BigNumber | null = null;
  /*FID=997*/
  public settleTenor: CubiqTS.Tenor;
  /*FID=998*/
  public settleDate: CubiqTS.moment.Moment | null = null;
  /*FID=999*/
  public fillDetails: CubiqTS.LastFillDetails | null = null;
  /*FID=1000*/
  public markupQty: CubiqTS.BigNumber | null = null;
  /*FID=1001*/
  public markupType: CubiqTS.MarkUpType;
  /*FID=1002*/
  public salesMarkup: CubiqTS.BigNumber | null = null;
  /*FID=1003*/
  public deskId: CubiqTS.Long | null = null;
  /*FID=1004*/
  public secondaryDeskId: CubiqTS.Long | null = null;
  /*FID=1005*/
  public componentAllocations: Array<CubiqTS.AllocationData> | null = null;
  /*FID=1006*/
  public accountName: string;
  /*FID=1007*/
  public usdEquivExecutedQty: CubiqTS.BigNumber | null = null;
  /*FID=1008*/
  public alternateAccountCode: string;
  /*FID=1009*/
  public oboAccount: string;
  /*FID=1010*/
  public creditRejectCd: CubiqTS.Long | null = null;
  /*FID=1011*/
  public allocationRef: string;
  /*FID=1012*/
  public fwdMarkupValue: CubiqTS.BigNumber | null = null;
  /*FID=1013*/
  public spotMarkupType: CubiqTS.MarkUpType;
  /*FID=1014*/
  public fwdMarkupType: CubiqTS.MarkUpType;
  /*FID=1015*/
  public spotMarkupValue: CubiqTS.BigNumber | null = null;
  /*FID=1016*/
  public reqFwdPoints: CubiqTS.BigNumber | null = null;
  /*FID=1017*/
  public spotAllocationQty: CubiqTS.BigNumber | null = null;
  /*FID=1018*/
  public spotSettleQty: CubiqTS.BigNumber | null = null;
  /*FID=1019*/
  public npvAllocationQty: CubiqTS.BigNumber | null = null;
  /*FID=1020*/
  public npvSettleQty: CubiqTS.BigNumber | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AllocationDataImplEncoder.Instance;
    this.setEncodableType(AllocationDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AllocationDataImpl[" +
      "messageId=" +
      this.messageId +
      "allocationId=" +
      this.allocationId +
      "riskId=" +
      this.riskId +
      "allocationReference=" +
      this.allocationReference +
      "allocationType=" +
      this.allocationType +
      "allocationIntent=" +
      this.allocationIntent +
      "accountCode=" +
      this.accountCode +
      "baseCcy=" +
      this.baseCcy +
      "nonbaseCcy=" +
      this.nonbaseCcy +
      "fixedCcy=" +
      this.fixedCcy +
      "allocationProductCd=" +
      this.allocationProductCd +
      "allocationQty=" +
      this.allocationQty +
      "settleQty=" +
      this.settleQty +
      "leavesQty=" +
      this.leavesQty +
      "leavesSettleQty=" +
      this.leavesSettleQty +
      "usdEquivQty=" +
      this.usdEquivQty +
      "usdEquivLeavesQty=" +
      this.usdEquivLeavesQty +
      "settleTenor=" +
      this.settleTenor +
      "settleDate=" +
      this.settleDate +
      "fillDetails=" +
      this.fillDetails +
      "markupQty=" +
      this.markupQty +
      "markupType=" +
      this.markupType +
      "salesMarkup=" +
      this.salesMarkup +
      "deskId=" +
      this.deskId +
      "secondaryDeskId=" +
      this.secondaryDeskId +
      "componentAllocations=" +
      this.componentAllocations +
      "accountName=" +
      this.accountName +
      "usdEquivExecutedQty=" +
      this.usdEquivExecutedQty +
      "alternateAccountCode=" +
      this.alternateAccountCode +
      "oboAccount=" +
      this.oboAccount +
      "creditRejectCd=" +
      this.creditRejectCd +
      "allocationRef=" +
      this.allocationRef +
      "fwdMarkupValue=" +
      this.fwdMarkupValue +
      "spotMarkupType=" +
      this.spotMarkupType +
      "fwdMarkupType=" +
      this.fwdMarkupType +
      "spotMarkupValue=" +
      this.spotMarkupValue +
      "reqFwdPoints=" +
      this.reqFwdPoints +
      "spotAllocationQty=" +
      this.spotAllocationQty +
      "spotSettleQty=" +
      this.spotSettleQty +
      "npvAllocationQty=" +
      this.npvAllocationQty +
      "npvSettleQty=" +
      this.npvSettleQty +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
